import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const StoresSection = styled.section`
  padding: 80px 50px;
  background-color: #f8f9fa;
  width: 100%;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #1d3557;
  margin-bottom: 40px;
  font-size: 2.5rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const StoresGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

const StoreCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const StoreName = styled.h3`
  color: #1d3557;
  font-size: 1.5rem;
  margin-bottom: 15px;
`;

const StoreInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #457b9d;
  
  svg {
    margin-right: 10px;
    min-width: 20px;
  }
`;

const Stores = () => {
  const stores = [
    {
      name: "New Malamba Business Equateur",
      address: "24/26 Avenue de l'Équateur, Gombe-Kinshasa, RD Congo",
      phone: "+243 994 999 555",
      email: "contact@malambabusiness.com"
    },
    {
      name: "New Malamba Business Kasa-Vubu",
      address: "37 Triangle Davié Av.Kasa-Vubu, Gombe-Kinshasa, RD Congo, Réf. Derrière ECO Bank/Grande Poste",
      phone: "+243 819 444 416",
      email: "contact@malambabusiness.com"
    },
    {
      name: "New Malamba Business Du Livre",
      address: "37 Triangle Davié Croisement Av.Kasa-Vubu et du Livre, Gombe-Kinshasa, RD Congo, Réf. Derrière ECO Bank/Grande Poste",
      phone: "+243 850 499 994",
      email: "contact@malambabusiness.com"
    }
  ];

  return (
    <StoresSection id="stores">
      <Title>Nos Points de Vente</Title>
      <StoresGrid>
        {stores.map((store, index) => (
          <StoreCard key={index}>
            <StoreName>{store.name}</StoreName>
            <StoreInfo>
              <FaMapMarkerAlt />
              {store.address}
            </StoreInfo>
            <StoreInfo>
              <FaPhone />
              {store.phone}
            </StoreInfo>
            <StoreInfo>
              <FaEnvelope />
              {store.email}
            </StoreInfo>
          </StoreCard>
        ))}
      </StoresGrid>
    </StoresSection>
  );
};

export default Stores;